import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { useLocation, useRouteMatch } from "react-router";
import { Planner } from "src/components";
import { PlannerViewMode } from "src/components/Planner/types";

function PlannerItemsView(): ReactElement {
    const isSmallViewMode = useSelector<Spintr.AppState, boolean>(
        (state) => state.ui.isSmallViewMode,
    );

    const location = useLocation();
    const initialViewMode: PlannerViewMode = location.pathname.endsWith("/agenda")
        ? "AGENDA"
        : location.pathname.endsWith("/list")
        ? "LIST"
        : "TIMELINE";

    return (
        <section id="PlannerItemsView">
            {/* <header className="PlannerItemsView-heading">
                <Heading color="contentDark" lineHeight="normal" weight="medium">
                    {localize("appPlanner")}
                </Heading>
            </header> */}
            
            <Planner initialTimelineMode={isSmallViewMode ? "MONTHS" : "WEEKS"} initialViewMode={initialViewMode} />
        </section>
    );
}

export default PlannerItemsView;
